import { render, staticRenderFns } from "./bip-free.vue?vue&type=template&id=29285b9b&"
import script from "./bip-free.vue?vue&type=script&lang=js&"
export * from "./bip-free.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports